module.exports = __webpack_public_path__ + "static/media/banner-artist.e307b85a.png";